import { NavLink, Link } from "react-router-dom";
import { Home, CalendarDays, Ticket, User } from "lucide-react";
import Logo from "./Logo";
import LanguageSwitcher from "./LanguageSwitcher";
import { useLang } from "../context/LangContext";

const items = [
  { to: "/home", icon: Home, key: "home", testid: "topnav-home" },
  { to: "/calendar", icon: CalendarDays, key: "calendar", testid: "topnav-calendar" },
  { to: "/trips", icon: Ticket, key: "trips", testid: "topnav-trips" },
  { to: "/profile", icon: User, key: "profile", testid: "topnav-profile" },
];

export function TopNav() {
  const { t } = useLang();
  return (
    <header
      className="hidden md:block sticky top-0 z-40 bg-brand-cream/85 backdrop-blur-xl border-b border-brand-tan/25"
      data-testid="top-nav"
    >
      <div className="mx-auto max-w-6xl px-8 py-5 flex items-center justify-between gap-6">
        <Link to="/home" className="shrink-0">
          <Logo size="md" />
        </Link>
        <nav className="flex items-center gap-1">
          {items.map(({ to, icon: Icon, key, testid }) => (
            <NavLink
              key={key}
              to={to}
              data-testid={testid}
              className={({ isActive }) =>
                `inline-flex items-center gap-2 px-4 py-2 rounded-full text-[11px] tracking-[0.22em] uppercase font-bold transition-colors ${
                  isActive
                    ? "bg-brand-brown text-brand-cream"
                    : "text-brand-tan hover:text-brand-brown hover:bg-white/60"
                }`
              }
            >
              <Icon size={14} strokeWidth={1.6} />
              {t(key)}
            </NavLink>
          ))}
        </nav>
        <div className="shrink-0">
          <LanguageSwitcher />
        </div>
      </div>
    </header>
  );
}

export default TopNav;
